function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M113.88,103.102c10.552-11.119,17.274-26.826,17.274-41.82c0-27.249-22.079-49.341-49.337-49.341 c-27.249,0-49.334,22.085-49.334,49.341c0,6.74,1.416,13.597,3.873,20.143c6.062,13.658,17.963,24.266,33.034,28.119 c2.987-3.689,7.49-5.9,12.428-5.9c8.856,0,16.066,7.204,16.066,16.063c0,8.86-7.21,16.058-16.066,16.058 c-6.306,0-11.883-3.678-14.499-9.17c-12.955-2.851-24.317-9.354-33.146-18.28c-19.439,8.306-32.047,21.531-32.047,36.462 c0,25.154,159.389,25.154,159.389,0C161.515,126.143,141.92,110.152,113.88,103.102z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.642,121.637c0.911,4.805,5.112,8.439,10.169,8.439c5.73,0,10.373-4.646,10.373-10.37s-4.643-10.37-10.366-10.37 c-4.403,0-8.139,2.753-9.646,6.625c-26.059-4.584-45.931-27.334-45.931-54.686c0-30.647,24.936-55.582,55.576-55.582 c30.655,0,55.585,24.935,55.585,55.582h5.687C143.089,27.492,115.603,0,81.817,0c-33.783,0-61.27,27.486-61.27,61.275 C20.542,91.593,42.697,116.766,71.642,121.637z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgCallCenterWorker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "163.641px",
    height: "163.641px",
    viewBox: "0 0 163.641 163.641",
    style: {
      enableBackground: "new 0 0 163.641 163.641"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenterWorker);
export default __webpack_public_path__ + "static/media/call-center-worker.89dd373f.svg";
export { ForwardRef as ReactComponent };